<template>
  <div class="header">
    <div class="content">
      <a href="/premium">
        <img class="pointer" src="~@/assets/img/premium/logo.png" alt="logo" />
      </a>
      <div class="searchInput-box">
        <div class="center">
          <img
            class="searchIcon"
            src="~@/assets/img/premium/search_icon.png"
            alt="search icon"
          />
        </div>
        <el-autocomplete
          class="searchInput fl"
          v-model="searchName"
          :popper-class="
            whiteListAutocomplete.includes($route.name)
              ? ''
              : 'autocomplete-hidden'
          "
          :fetch-suggestions="querySearch"
          :placeholder="$t('header.searchPlaceholder')"
          :trigger-on-focus="false"
          :select-when-unmatched="true"
          @select="searchByChoosed"
        >
          <template slot-scope="{ item }">
            <span v-html="item.name" class="search-list"></span>
          </template>
        </el-autocomplete>
        <div class="searchButton" @click="searchByChoosed">搜索</div>
      </div>
      <div class="flex-align-center">
        <el-dropdown
          class="header-top-company-dropdown mr-16"
          v-show="
            $store.state.user.companyAccountInfo &&
            $store.state.user.companyAccountInfo.length
          "
          placement="top-start"
          trigger="click"
        >
          <span class="company-name pointer black">
            <span class="premiumHeader-company-name">{{ $store.state.user.defaultCompanyName }}</span> 
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            :model="companyList"
            class="dropdown-menu"
          >
            <el-input
              class="company-input"
              :placeholder="$t('header.companyName')"
              clearable
              v-if="$store.state.user.companyAccountInfo.length > 5"
              v-model.trim="dropdownCompanyName"
            >
            </el-input>
            <i
              class="el-icon-search"
              v-if="
                $store.state.user.companyAccountInfo.length > 5 &&
                dropdownCompanyName.length < 1
              "
            ></i>
            <el-dropdown-item v-for="item in companyList" :key="item.companyId">
              <div class="company-item company-name">
                <el-tooltip
                  placement="bottom"
                  effect="light"
                  :disabled="!tooltipFlag"
                  :enterable="false"
                >
                  <div slot="content">
                    {{ item.companyName }}
                  </div>

                  <div
                    class="ellipsis flex-grow"
                    @click.stop="changeCompany(item)"
                    @mouseenter="handleTooltipIn($event)"
                    @mouseleave="handleTooltipOut($event)"
                  >
                    {{ item.companyName }}
                  </div>
                </el-tooltip>
                <div class="flex-shrink" @click.stop="changeCompany(item)">
                  {{
                    item.companyId === item.defaultCompanyId
                      ? $t('header.memberCenter')
                      : $t('header.switch')
                  }}
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-show="haveToken || $store.state.user.name">
          <span class="company-name pointer black">
            {{ $store.state.user.name
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logoutHandle()">{{
              $t('header.exit')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getEnvConfig } from '@/utils/envConfig.js'
import { getAccessToken } from '@/utils/userInfo'
import { clearLoginInfo } from '@/utils'

export default {
  data () {
    return {
      searchName: '',
      whiteListAutocomplete: [
        'goodDetail',
        'main',
        // 'goodSearchCategoryList',
        'premiumGoodCategoryList',
        'premiumHome'
      ],
      dropdownCompanyName: '',
      tooltipFlag: false
    }
  },
  computed: {
    companyList () {
      let list = this.$store.state.user.companyAccountInfo
      //   console.log("companyList", list);

      if (list.length === 0) {
        return list
      } else if (this.dropdownCompanyName.length < 2) {
        return list
      } else {
        return list.filter(
          (item) =>
            item.companyName
              .toLowerCase()
              .indexOf(this.dropdownCompanyName.toLowerCase()) !== -1
        )
      }
    },
    haveToken () {
      let token = getAccessToken()
      let result = false
      if (token && token !== 'null' && token !== 'undefind' && token !== '') {
        result = true
      }
      return result
    }
  },
  methods: {
    // 切换公司
    changeCompany (item) {
      console.log('changeCompany')

      if (item.resignFlag === true) {
        // 已离职
        this.$confirm(this.$t('navbar.leave'), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          showCancelButton: false,
          type: 'warning'
        })
          .then(() => {})
          .catch(() => {})
        return
      }
      if (item.companyId === item.defaultCompanyId) {
        // 跳转会员中心
        this.$router.push({
          name: 'basicInfo'
        })
      } else {
        this.$store.commit('company', item)
        // 切换默认公司
        this.$store.commit('setLoadStatus', true)
        this.$http
          .post(`/front/consumer/usercenter/updateDefCompanyId`, {
            companyId: item.companyId
          })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            // 请求新用户数据
            this.$http
              .get('/front/consumer/usercenter/custUserCenterInfo', {
                params: {
                  appCode: 'PLANTMATE_OFFICIAL',
                  companyId: item.companyId
                }
              })
              .then(({ data: res }) => {
                if (res.code !== 0) {
                  return false
                }
                // 设置用户信息
                this.$store.dispatch(
                  'companyList',
                  res.data.companyAccountInfo || []
                )
                this.$store.dispatch('setUserInfo', res.data.userInfo)
                Cookies.set('userId', res.data.userInfo.userId)
                Cookies.set('mobile', res.data.userInfo.mobile)

                // 获取生态服务用户数据
                this.getEcologyUserInfo(res.data.userInfo.userId)
                this.getCorpUser();

                // 重新请求用户菜单，关闭loading，切换到个人中心
                // this.bus.$emit('getUserMenuPerm')
                window.SITE_CONFIG['menuList'] = []
                this.$store.commit('setMenuList', [])
                console.log('切换公司0')
                this.$http
                  .get(
                    `/front/consumer/menu/bar/${window.SITE_CONFIG['appCode']}`
                  )
                  .then(({ data: res }) => {
                    if (res.code !== 0) {
                      return false
                    }
                    window.SITE_CONFIG['menuList'] = res.data.tree
                    this.$store.commit('setMenuList', res.data.tree)
                    window.SITE_CONFIG['permissions'] = res.data.api
                    // 判断有无 订单列表 有则跳，没有则跳到首页
                    this.$store.commit('setLoadStatus', false)
                    // 个人中心应该返回的路由权限集合
                    const routeMaps = [
                      'InvitationRegister',
                      'myPT',
                      'myShopCart',
                      'organization',
                      'NeedSendOrders',
                      'ShareDownload',
                      'MyWorkbench',
                      'integralManagment',
                      'signIn',
                      'equipmentList',
                      'basicInfo',
                      'selfOperation',
                      'rdmsOrderList',
                      'onlineService',
                      'orderList',
                      'solveSonsultList',
                      'serviceSonsultList',
                      'myInquiryCart',
                      'inquiryList',
                      'ShopCart',
                      'DailyBonus',
                      'examList',
                      'myAnswer',
                      'myInvitation',
                      'buyInvite',
                      'myBought',
                      'myCoupon',
                      'CourseHistory',
                      'myStudy',
                      'studyStatistics',
                      'liveTraining',
                      'myCollection',
                      'mySubscribe',
                      'myUpload',
                      'myDownload',
                      'myComment',
                      'myEvaluate',
                      'myQuestions',
                      'myAdvice',
                      'sparePartsLibrary',
                      'spareRequirementsList',
                      'spareGetList',
                      'spareStatementList',
                      'demandManage',
                      'securityConsole'
                    ]
                    // 新增个性化页面的详情页集合，遇到这些页面时直接调整首页
                    const personalMaps = [
                      'spareRequirementsDetail',
                      'spareGetDetail',
                      'orderDetail',
                      'spareRequirementsUpdate',
                      'spareGetDetailUpdate',
                      'orderPay',
                      'demandDetail'
                    ]
                    console.log('切换公司')

                    // 筛选出当前有的路由权限
                    const keymap =
                      res.data.tree &&
                      res.data.tree
                        .filter(
                          (res) =>
                            res.children && res.children.length && res.showLeft
                        )
                        .map((res) => res.children)
                        .flat()
                        .map((res) => res.menuUrl)
                    /**
                     * 如果当前页面属于个性化页面，比如商品详情页，此时直接跳转首页
                     * 如果当前页面包含在固定路由权限集合中
                     * 则进一步判断当前账号有无其中的路由权限(拿到账号路由权限进行匹配判断)
                     * 如果有其中的权限，则刷新当前页面，让页面刷新
                     * 如果没有权限，则跳转到首页
                     * 如果当前页面并不需要权限判断，则直接刷新当前页面即可
                     */
                    if (personalMaps.includes(this.$route.name)) {
                      this.$router.push({ name: 'main' })
                    } else if (routeMaps.includes(this.$route.name)) {
                      if (keymap && keymap.includes(this.$route.name)) {
                        this.$store.commit('resetRefresh', false)
                        this.$nextTick(() => {
                          this.$store.commit('resetRefresh', true)
                        })
                      } else {
                        this.$router.push({ name: 'main' })
                      }
                    } else {
                      this.$store.commit('resetRefresh', false)
                      this.$nextTick(() => {
                        this.$store.commit('resetRefresh', true)
                      })
                    }
                    this.bus.$emit('companyResetRefresh')
                    this.$message.success(this.$t('navbar.switchSuccess'))
                    window.location.reload()
                  })
                  .catch(() => {})
              })
              .catch(() => {})
          })
          .catch(() => {})
      }
    },
    getEcologyUserInfo (userId) {
      return this.$http
        .get(`/front/oms/supplier/User/getSsoUserInfoByUserId/${userId}`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            // 手动修改用户类型
            // res.data.userType = 2
            this.$store.commit('setEcologyUserInfo', res.data)
          }
        })
    },
    getCorpUser() {
      return this.$http
        .get("/front/sys/crop-site/customer-crop-site")
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit("setCorpUserInfo", res.data || {});
          }
        });
    },
    // 设置超出隐藏的展示tootip
    handleTooltipIn (event) {
      this.tooltipFlag = event.target.scrollWidth > event.target.offsetWidth
    },
    handleTooltipOut () {
      this.tooltipFlag = false
    },
    goInquiry () {
      this.$router.push({ name: 'selectionCategoryList' })
    },
    searchByInput () {
      if (this.$route.path === '/sparePartsLibrary') {
        this.bus.$emit('getUserStoreSpare', this.searchName)
      } else if (this.$route.path === '/courseList') {
        this.bus.$emit('getUserCourseList', this.searchName)
      } else if (this.$route.path === '/onlineTraining') {
        Cookies.set('getUserCourseListindex', '1')
        Cookies.set('searchName', this.searchName)
        this.$router.push({
          name: 'courseList'
        })
      } else if (this.menuTypes === 'selectionInquiry') {
        if (this.$route.query.search === this.searchName) return
        this.$router
          .push({
            name: 'selectionCategoryList',
            query: {
              search: this.searchName || ''
            }
          })
          .then(() => {
            this.searchName = this.$route.query.search
          })
      } else {
        if (this.$route.query.search === this.searchName) {
          this.$router.push({
            name: 'goodnull',
            query: {
              search: this.searchName,
              foregroundCategoryId: '',
              brandIdList: '',
              seriesIdList: '',
              attributeValueIdList: '',
              salesDesc: false,
              priceDesc: false,
              popularityDesc: false,
              premium: 1
            }
          })
          return
        }
        if (this.searchName) {
          let query = {
            search: this.searchName,
            foregroundCategoryId: '',
            brandIdList: '',
            seriesIdList: '',
            attributeValueIdList: '',
            salesDesc: false,
            priceDesc: false,
            popularityDesc: false
          }
          let queryStr = Object.keys(query)
            .map((v) => `${v}=${query[v]}`)
            .join('&')
          window.open('/premiumGoodCategoryList?' + queryStr)
          // this.$router.push({
          //   name: 'premiumGoodCategoryList',
          //   query: {
          //     search: this.searchName,
          //     foregroundCategoryId: '',
          //     brandIdList: '',
          //     seriesIdList: '',
          //     attributeValueIdList: '',
          //     salesDesc: false,
          //     priceDesc: false,
          //     popularityDesc: false
          //   }
          // })
        } else {
          let query = {
            search: '',
            foregroundCategoryId: '',
            brandIdList: '',
            seriesIdList: '',
            attributeValueIdList: '',
            salesDesc: false,
            priceDesc: false,
            popularityDesc: false
          }
          let queryStr = Object.keys(query)
            .map((v) => `${v}=${query[v]}`)
            .join('&')
          window.open('/premiumGoodCategoryList?' + queryStr)
          // this.$router.push({
          //   name: 'premiumGoodCategoryList',
          //   query: {
          //     search: '',
          //     foregroundCategoryId: '',
          //     brandIdList: '',
          //     seriesIdList: '',
          //     attributeValueIdList: '',
          //     salesDesc: false,
          //     priceDesc: false,
          //     popularityDesc: false
          //   }
          // })
        }
      }
    },
    searchByChoosed (val) {
      let divv = document.createElement('div')
      divv.innerHTML = val.name
      if (!val.spuId) {
        this.searchByInput()
      } else {
        this.searchName = divv.innerText
        window.open('/goodDetail?spuId=' + val.spuId)
        // this.$router.push({
        //   name: 'goodDetail',
        //   query: {
        //     spuId: val.spuId
        //   }
        // })
      }
      divv = null
    },
    querySearch (queryString, cb) {
      let list = []
      if (this.whiteListAutocomplete.includes(this.$route.name)) {
        this.$http
          .get(`/front/cross/commodity-user/web/spu-name/list`, {
            params: {
              search: queryString,
              boutiqueCategoryId: this.$route.query.foregroundCategoryId || 0
            }
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                cb(res.data)
              } else {
                cb(list)
              }
            } else {
              cb(list)
            }
          })
      } else {
        cb(list)
      }
    },
    // 退出
    logoutHandle () {
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('logout') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          // let tok = ''
          // if (
          //   getAccessToken() &&
          //   getAccessToken() !== 'undefind' &&
          //   getAccessToken() !== 'null'
          // ) {
          //   tok = getAccessToken()
          // }
          this.$http
            .delete(
              `/auth/user/token?access_token=${getAccessToken()}&env=${
                getEnvConfig().env
              }&domain=${getEnvConfig().domain}&appCode=PLANTMATE_OFFICIAL`,
              {
                access_token: getAccessToken()
              }
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              clearLoginInfo()
              this.$router.push({ name: 'login' })
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    toUserInfo () {
      this.$router.push({
        name: 'basicInfo'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  min-width: calc(100vw - 56px);
  height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Alibaba PuHuiTi;
  background-image: url('~@/assets/img/main/main_bg.png') !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1190px;
  }

  .searchInput-box {
    position: relative;
    display: flex;
    background: #ffffff;
    width: 509px;
    padding: 4px 4px 4px 16px;
    border-radius: 12px;
  }

  .searchInput {
    // width: 486px;
    flex: 1;
    /deep/.el-input__inner {
      height: 38px;
      border-radius: 25px;
      border: none;
      padding: 0 8px;
      &:focus {
        border: none;
      }
      &::placeholder {
        color: #cccccc;
      }
    }
  }
  .searchIcon {
    width: 16px;
    height: 16px;
  }
  .searchButton {
    background: #2a54d1;
    width: 88px;
    height: 40px;
    line-height: 8px;
    text-align: center;
    padding: 16px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
  .top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    // background: #fff;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: #333;
    flex-shrink: 0;
    .top-content {
      width: 1190px;
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-between;
    }
    .company-name {
      font-family: Alibaba PuHuiTi;
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
      text-align: left;
      color: #333;
    }
  }
}
.dropdown-menu {
  max-height: 480px;
  height: auto;
  overflow: auto;

  .company-input {
    border-radius: 2px !important;
    width: 85% !important;
    padding: 5px 0 10px 10px;
    margin-left: 10px;
  }

  .el-icon-search {
    position: relative;
    right: 25px;
    font-size: 15px;
  }

  .company-item {
    display: flex;
    width: 260px;
    justify-content: space-between;
    font-family: Alibaba PuHuiTi;
  }
}
.mr-16 {
  margin-right: 16px;
}
.mr-30 {
  margin-right: 30px;
}
.black {
  color: #1a1a1a;
  font-size: 16px;
  line-height: 24px;
}
.flex-align-center{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style lang="scss">
.premiumHeader-company-name{
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: right;
  color: #333;
  display: inline-block;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  top: 3px;
}
.autocomplete-hidden {
  display: none;
}

.el-tooltip__popper {
  pointer-events: none !important;
}
</style>
